// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__fuSBA","calendarButtons":"ClockData_calendarButtons__3aGtD"};